import { Grid } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import cx from "classnames";
import type { ReactElement } from "react";
import { SearchLayoutMemo } from "src/component/element";
import { Sidebar } from "src/layout/AppLayout/Sidebar";

import styles from "../PageMain/PageMain.module.scss";

export const PageMainSearch = ({
  page,
  searchViewText,
}: {
  page: ReactElement;
  searchViewText: string;
}) => {
  const matche = useMediaQuery("(min-width: 768px)");

  return (
    <Grid className={styles.grid}>
      <Grid.Col
        span={matche ? 3 : 0}
        className={cx(styles.sidebar, styles.col)}
      >
        <Sidebar />
      </Grid.Col>
      <Grid.Col span={matche ? 9 : 12} className={styles.col}>
        <SearchLayoutMemo text={searchViewText}>
          <main className={styles.main}>{page}</main>
        </SearchLayoutMemo>
      </Grid.Col>
    </Grid>
  );
};
